import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import styled from "styled-components";
import Section from "./Section";
import Icon from "./Icon";
import Rating from "./Rating";
import ReactDOM from "react-dom";

const Container = styled.div`
  padding: 0 1.25rem;
  
  .container {
    display: inline-block;
  }
  
  @media only screen and (min-width: 1024px) {
    padding: 0;
    
    .container {
      margin-left: 50%;
      transform: translate(-50%);
    }
  }
`;

const Button = styled.a`
  margin: 0;
  z-index: 1;
  outline: 0;
  border: none;
  cursor: pointer;
  display: block;
  padding: 0 1rem;
  height: 3.125rem;
  font-weight: 700;
  width: max-content;
  text-align: center;
  position: relative;
  color: var(--white);
  font-size: 0.875rem;
  line-height: 3.125rem;
  border-radius: .313em;
  text-decoration: none;
  box-sizing: border-box;
  background-color: var(--secondary);
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
  &:hover,
  &:focus {
    background: var(--lightenButton)
  }
`;

const Content = styled.div`
  h2, h3 {
    margin-bottom: 0.5rem;
  }
`;

const CardContainer = styled.a`
  outline: none;
  color: #000000;
  cursor: pointer;
  text-decoration: none;
  background: transparent;
  margin-bottom: 0.625rem;
  padding-bottom: 0.625rem;
  width: calc((100% - 2rem)/3);
  
  img {
    object-fit: cover;
  }
  &:last-of-type {
    margin-bottom: 0;
    border-bottom: none;
  }
  @media only screen and (min-width: 1024px) {
    padding: 0;
    cursor: pointer;
    border-radius: .25rem;
    margin-bottom: 1.25rem;
  }
`;

const CardBody = styled.div`
  padding: 0 0 .5rem;
`;

const Title = styled.h3`
  font-size: 1rem;
  overflow: hidden;
  line-height: 1.5;
  margin-bottom: 0;
  font-weight: bold;
  padding-top: 1rem;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Stars = styled.div`
  display: inline-flex;
  flex-direction: row;
  cursor: help;
  padding-top: .25rem;
  padding-bottom: .5rem;
  height: 1rem;
  position:relative;
  
  p {
    font-size: 1rem;
    line-height: 1.2rem;
    margin-right: .25rem;
  }
  
  svg {
    height: 1rem !important;
    width: 1rem !important;
  }
`;

const StarsInfo = styled.div`
  z-index: 1;
  padding: .5rem;
  width: 12rem;
  background: white;
  color: #191B1B;
  font-size: .75rem;
  border-radius: .25rem;
  border: 1px solid #EBE7F2;
  box-shadow: 0 0 .313rem #eae7e4;
  
  @media only screen and (min-width: 1024px) {
    width: 15.625rem;
  }
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  border-right: 11px solid #ebe7f2;
  position: absolute;
  bottom: -1rem;o
  left: 1rem;
  transform: rotate(-90deg);
  
  @media only screen and (min-width: 1024px) {
    bottom: -1rem;
    right: calc(85% - 0.313rem);
    transform: rotate(-90deg);
  }
  
  div {
    position: relative;
    top: -.625rem;
    left: 2px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #FFF;
  }
`;

const StarsContainer = styled.div`
  transition: .3s;
  padding-top: .938rem;
  background: transparent;
  position: absolute;
  left: 0;
  bottom: 2rem;
  display: ${props => props.visible ? "block" : "none"};
`;

const AddressContainer =styled.div`
  padding-bottom: ${props => props.isDistance? "" : "1.438rem"};
`;

const Address = styled.div`
  font-size: .75rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Distance = styled.div`
  font-size: .75rem;
  padding-bottom: 0.5rem;
`;

const PriceCopy = styled.div`
  font-size: .75rem;
  
  b {
    padding-right:.25rem;
    padding-left:.25rem;
  }
  
  span {
    padding-left: .25rem;
  }
`;

const RatingContainer = styled.div`
  margin-top: ${props => props.isTotal ? "0" : "0.875rem"};
  
  b {
    color: var(--primary);
  }
`;

const Image = styled.img`
  height: 10rem;
  width: 100%;
  border-radius: 0.25rem;

  @media only screen and (min-width: 1024px) {
    height: 14rem;
  }
`;

const SliderStyled = styled(Slider)`
  margin-top: 1.25rem;
  display: ${props => props.displayAsGridBlock ? "block" : "none"};
  
  .slick-list {
    margin: 0 -.25rem;
  }
  
  .slick-track {
    display: flex !important;
    margin: 0;
  }
  
  .slick-slide {
    height: 22rem;
    margin: 0 .25rem;
    position: relative;
    
    @media only screen and (min-width: 1024px) {
      height: 26.5rem;
    }
  }
  
  .slick-slide > div {
    height: 100%;
  }
  
  .slick-dots {
    display: none !important;
  }
  
  .slick-arrow {
    display: none;
  }
  
  @media only screen and (min-width: 1024px) {
    display: ${props => props.displayAsGridBlock ? "none" : "block"};

    .slick-arrow {
      padding: 0;
      z-index: 2;
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      position: absolute;
      align-items: center;
      background: #FAFAFA;
      border-radius: 2.5rem;
      top: calc(50% - 1.25rem);
      justify-content: center;
      box-shadow: 0 1px 2px 0 rgba(151, 151, 151, 1);
      -moz-box-shadow: 0 1px 2px 0 rgba(151, 151, 151, 1);
      -webkit-box-shadow: 0 1px 2px 0 rgba(151, 151, 151, 1);
      
      &:hover {
        background: var(--primary);
      }
      
      &.slick-next {
        right: -1.5rem;
        
        &::before {
          content: '';
          width: 0.625rem;
          height: 1.25rem;
          display: block;
          position: absolute;
          left: calc(50% - 5px);
          top: calc(50% - 10px);
          background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMTQgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+VmVjdG9yPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJsb2RnZXMvLWNvcHktMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg2NC4wMDAwMDAsIC01NTEuMDAwMDAwKSIgZmlsbD0iIzAwMDAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGcgaWQ9IlByb3AtaW1hZ2VzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDAuMDAwMDAwLCAyMDkuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iTG9jYXRpb24tcGluIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MzAuMDAwMDAwLCAzNTUuMDAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC03MzAuMDAwMDAwLCAtMzU1LjAwMDAwMCkgdHJhbnNsYXRlKDcwNS4wMDAwMDAsIDMzMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjcuNTA5ODI4MSwzNy4zMjk5Mjc1IEMyNy4yNjg3OTM4LDM3LjIxNTU5MDcgMjcuMDU2NDM5OSwzNy4wNDg2OTk5IDI2Ljg4ODM3MTQsMzYuODQxNTIwMiBMMTguMjYzMzcxNSwyNi4xMjcyMzYyIEMxOC4wMDA3MjU0LDI1LjgwNzcxMyAxNy44NTcxNDI5LDI1LjQwNjkyMzEgMTcuODU3MTQyOSwyNC45OTMzMDcyIEMxNy44NTcxNDI5LDI0LjU3OTY5MTQgMTguMDAwNzI1NCwyNC4xNzg5MDE1IDE4LjI2MzM3MTUsMjMuODU5Mzc4MyBMMjcuMTkxOTQyOSwxMy4xNDUwOTM1IEMyNy40OTUwNDc1LDEyLjc4MDQyMDkgMjcuOTMwNjAyOCwxMi41NTEwOTE1IDI4LjQwMjc5MjYsMTIuNTA3NTU2MiBDMjguODc0OTgyNCwxMi40NjQwMjEgMjkuMzQ1MTI3MSwxMi42MDk4NDU5IDI5LjcwOTc5OTgsMTIuOTEyOTUwNCBDMzAuMDc0NDcyNSwxMy4yMTYwNTUgMzAuMzAzODAxLDEzLjY1MTYxMTEgMzAuMzQ3MzM2MiwxNC4xMjM4MDA5IEMzMC4zOTA4NzE0LDE0LjU5NTk5MDcgMzAuMjQ1MDQ3NCwxNS4wNjYxMzQ1IDI5Ljk0MTk0MjksMTUuNDMwODA3MiBMMjEuOTU5Nzk5NSwyNS4wMDIyMzYgTDI5LjY3NDA4NDcsMzQuNTczNjY1NyBDMjkuODkyNDQ3NCwzNC44MzU3ODE2IDMwLjAzMTE1NjUsMzUuMTU0OTYwMyAzMC4wNzM3OTg2LDM1LjQ5MzQ0MDMgQzMwLjExNjQ0MDYsMzUuODMxOTIwMiAzMC4wNjEyMzE5LDM2LjE3NTUzNDcgMjkuOTE0NzAzNSwzNi40ODM2MTk5IEMyOS43NjgxNzUyLDM2Ljc5MTcwNTEgMjkuNTM2NDYwOSwzNy4wNTEzNjgxIDI5LjI0Njk3ODIsMzcuMjMxODg2NCBDMjguOTU3NDk1NiwzNy40MTI0MDQ2IDI4LjYyMjM2MDIsMzcuNTA2MjIxNCAyOC4yODEyMjgsMzcuNTAyMzU4NiBDMjguMDE0NDUxNiwzNy41MDMxNDMxIDI3Ljc1MDg2MjUsMzcuNDQ0MjY0MyAyNy41MDk4MjgxLDM3LjMyOTkyNzUgWiIgaWQ9IlZlY3RvciI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=);
          background-size: 0.625rem 1.25rem;
        }
      }
      
      &.slick-prev {
        left: -1.5rem;
        
        &::before {
          content: '';
          width: 0.625rem;
          height: 1.25rem;
          display: block;
          position: absolute;
          top: calc(50% - 10px);
          left: calc(50% - 7px);
          background-image: url(data:image/svg+xml;base64,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);
          background-size: 0.625rem 1.25rem;
        }
      }
      
      &.slick-disabled {
        display: none !important;
      }
    }
  }
`;

const Grid = styled.div`
  display: none;
  
  @media(min-width: 1024px) {
    display: grid;
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Card = ({index, url, property, toggleStarsInfo, visibleStarsInfo, renderStars, formattedDistance, nights}) => {
  return (
    <React.Fragment>
      <CardContainer href={url}>
        {property.images.length > 0 &&
          <Image loading="lazy" src={property.images[0].small} alt={property.name}/>
        }
        <CardBody>
          <Title>{property.name}</Title>
          <Stars title={property.rating.stars + " stars"}
                 onClick={(e) => toggleStarsInfo(index, e)}
                 onMouseEnter={() => toggleMouseStarsInfo(true, index)}
                 onMouseLeave={() => toggleMouseStarsInfo(false, index)}>
            {renderStars(property.rating.stars)}
            <StarsContainer visible={visibleStarsInfo === index}
                            onMouseEnter={() => toggleMouseStarsInfo(true, index)}
                            onMouseLeave={() => toggleMouseStarsInfo(false, index)}>
              <StarsInfo>
                <Triangle>
                  <div/>
                </Triangle>
                This star rating is provided to LateRooms by the property. It is usually determined
                by an official hotel rating organisation or another third party.
              </StarsInfo>
            </StarsContainer>
          </Stars>
          <AddressContainer isDistance={property.distance !== null}>
            <Address>
              {property.address.line1 && property.address.line1}, {property.address.city && property.address.city}&nbsp;
            </Address>
          </AddressContainer>
          {property.distance && property.distance !== "0" && property.distance !== null &&
            <Distance>
              {formattedDistance(property.distance)}&nbsp;mi from centre
            </Distance>
          }
          {property.total &&
            <PriceCopy>
              From
              {property.total && <b>
                £{property.total.toLocaleString()}
              </b>}
              per
              {nights > 1 ?
                <span>nights</span>
                :
                <span>night</span>
              }
            </PriceCopy>
          }
          <RatingContainer isTotal={property.total !== null}>
            {property.rating.guestRating > 0 &&
              <Rating rating={property.rating.guestRating}
                      reviews={property.rating.guestCount}
              />
            }
          </RatingContainer>
        </CardBody>
      </CardContainer>
      <Button href={url} target="_blank">
        Check availability
      </Button>
    </React.Fragment>
  )
}

const HotelList = ({title, subtitle, linkItem, lrHotelList, displayAsGridBlock}) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [visibleStarsInfo, setStarsInfoVisible] = useState(null);
  const [mouseOnStars, setMouseOnStars] = useState(false);

  const slider = useRef(null);

  const settings = {
    fade: false,
    dots: false,
    arrows: true,
    lazyLoad: true,
    slidesToShow: 3,
    infinite: false,
    initialSlide: 0,
    slidesToScroll: 3,
    beforeChange: (current, next) => {
      setSlideIndex(next);
    },
    // mobile settings
    responsive: [
      {
        breakpoint: 992,
        settings: {
          swipe: true,
          arrows: false,
          slidesToShow: lrHotelList && lrHotelList.length > 2 ? 2.5 : 2,
          swipeToSlide: true,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          swipe: true,
          arrows: false,
          slidesToShow: lrHotelList && lrHotelList.length > 1 ? 1.5 : 1,
          swipeToSlide: true,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const formattedDistance = (distance) => {
    return  parseFloat(distance).toFixed(2);
  };

  const renderStars = (stars) => {
    const totalAmount = 5;
    return [...Array(totalAmount)].map((el, i) =>
      i < stars && i + 1 > stars ? (
          <Icon key={i} name="icon-half-star"/>
        ) :
        i < stars ? (
          <Icon key={i} name="icon-star"/>
        ) : (
          <div key={i}/>
        ),
    );
  };

  const toggleStarsInfo = (index, e) => {
    e.preventDefault();
    setStarsInfoVisible(index);
  };

  const toggleMouseStarsInfo = (boolean) => {
    setMouseOnStars(boolean);

    if (visibleStarsInfo !== null && boolean === false) {
      setTimeout(() => {
        setStarsInfoVisible(null);
      }, 500);
    }
  };

  let thisFriday = new Date();
  const day = thisFriday.getDay();
  const targetDay = 5;  // Friday
  let dayOffset = targetDay - day;
  if (dayOffset < 0) dayOffset += 7;

  thisFriday = new Date(thisFriday.getTime() + (dayOffset * 24 * 3600 * 1000));

  let thisMonday = new Date(thisFriday);
  const numberOfDayToAdd = 3;
  thisMonday.setDate(thisMonday.getDate() + numberOfDayToAdd );

  thisFriday = thisFriday.toISOString().split('T')[0];
  thisMonday = thisMonday.toISOString().split('T')[0];

  const defaultCheckIn = thisFriday;
  const defaultCheckOut = thisMonday;
  const defaultNights = 3;

  function handleRegionForUrl(val) {
    return val.replace(/\.|\,|\'/g, "").replace(/\&/g, "and").replace(/ /g, "-");
  }

  return (
    <Section>
      <Container>
        <div className="container">
          <div className="col-1 hidden-m"/>
          <div className="col-10">
            <Content>
              {title &&
                <h2>{title}</h2>
              }
              {subtitle &&
                <h3>{subtitle}</h3>
              }
              {lrHotelList && lrHotelList.length > 0 &&
                <React.Fragment>
                  {displayAsGridBlock &&
                    <Grid>
                      {lrHotelList.map((property, index) => {
                          let url = "https://www.laterooms.com/hotel/" + (property.urlRegion ? handleRegionForUrl(property.urlRegion.toLowerCase()) : "united-kingdom") +"/" + property.slug + "/?checkin=" + defaultCheckIn + "&checkout=" + defaultCheckOut + "&nights="+ defaultNights + "&rooms=" + encodeURIComponent('[{"adults":2,"children":[],"kidsAge":[]}]');

                          return (
                          <div key={index}>
                            <Card index={index} url={url} property={property} nights={defaultNights}
                                  formattedDistance={formattedDistance} renderStars={renderStars}
                                  toggleStarsInfo={toggleStarsInfo} visibleStarsInfo={visibleStarsInfo}/>
                          </div>
                        )}
                        )
                      }
                    </Grid>
                  }
                  <SliderStyled {...settings} ref={slider} displayAsGridBlock={displayAsGridBlock}>
                    {lrHotelList.map((property, index) => {
                      let url = "https://www.laterooms.com/hotel/" + (property.urlRegion ? handleRegionForUrl(property.urlRegion.toLowerCase()) : "united-kingdom") +"/" + property.slug + "/?checkin=" + defaultCheckIn + "&checkout=" + defaultCheckOut + "&nights="+ defaultNights + "&rooms=" + encodeURIComponent('[{"adults":2,"children":[],"kidsAge":[]}]');
                      return (
                        <React.Fragment>
                          <div className="slide" key={index}>
                            <Card index={index} url={url} property={property} nights={defaultNights}
                                  formattedDistance={formattedDistance} renderStars={renderStars}
                                  toggleStarsInfo={toggleStarsInfo} visibleStarsInfo={visibleStarsInfo}/>
                          </div>
                        </React.Fragment>
                      )}
                    )}
                  </SliderStyled>
                </React.Fragment>
              }
              {linkItem &&
                <Button href={linkItem.link} className="btn">{linkItem.copy}</Button>
              }
            </Content>
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default HotelList;